/** Shared property category tree (mirrors backend). */
export const PROP_CATEGORIES = {
  residential: { label: "Residential", emoji: "🏠", subs: ["house","apartment","villa","townhouse","condominium","duplex","mobile-home"] },
  land:        { label: "Land",        emoji: "🌾", subs: ["residential-lot","agricultural","commercial-land","farm-land","plantation","investment"] },
  commercial:  { label: "Commercial",  emoji: "🏢", subs: ["office","retail","shopping-center","hotel","warehouse","factory","restaurant-space"] },
  rental:      { label: "Rentals",     emoji: "🏘️", subs: ["apartment-rent","house-rent","condo-rent","office-rent","shop-rent","vacation-rental","homestay","room-for-rent","paying-guest","student-housing"] },
};

export function propLabel(slug) {
  return (slug || "").split("-").map((w) => w[0]?.toUpperCase() + w.slice(1)).join(" ");
}

export function propGroupFor(sub) {
  for (const [gid, g] of Object.entries(PROP_CATEGORIES)) {
    if (g.subs.includes(sub)) return { id: gid, ...g };
  }
  return null;
}
